import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/core/app.state";
import { CommonService } from "src/app/shared/common.service";
import * as comparatorsActions from "./comparator.actions";
import { catchError, finalize, map, mergeMap, of, switchMap, tap } from "rxjs";
import { ComparatorService } from "../services/comparator.services";
import { IComparator } from "../models/comparator.models";
import { APIResponse } from "src/app/core/models/api-response";
import { IExecuteSeccess, IResponseMatching } from "../../imports/models/imports.models";
import { AlertEnums } from "src/app/shared/enums/shared.enums";
import { TranslateService } from "@ngx-translate/core";


@Injectable()
export class ComparatorEffects {
  constructor(
    private actions$: Actions,
    public store: Store<AppState>,
    private comparatorService: ComparatorService,
    private commonService: CommonService,
    private translateService: TranslateService
  ) {}

  GetComparatorsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(comparatorsActions.GetComparators),
      tap(() => {
        this.store.dispatch(comparatorsActions.SetComparatorLoader({isLoading: true}));
      }),
      switchMap((action) =>
        this.comparatorService.listComparators().pipe(
          map((res: APIResponse<IComparator>) => comparatorsActions.GetComparatorsSuccess({ Comparators: res })),
          catchError(() =>
            of(
            comparatorsActions.GetComparatorsError()
            )),
            finalize(() => {
              this.store.dispatch(comparatorsActions.SetComparatorLoader({isLoading: false}));
            })
        )
      )
    )
  );

  importComparatorsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(comparatorsActions.ImportComparators),
      tap(() => {
        this.store.dispatch(comparatorsActions.SetComparatorLoader({isLoading: true}));
      }),
      switchMap((action) =>
        this.comparatorService.importComaparators(action.file).pipe(
          map((res: APIResponse<IResponseMatching>) => comparatorsActions.ImportComparatorsSuccess({ responseMatching: res.object!, reimport: action.reimport})),
          catchError(() =>
            of(
            comparatorsActions.ImportComparatorsError()
            )
          ),
            finalize(() => {
              this.store.dispatch(comparatorsActions.SetComparatorLoader({isLoading: false}));
            })
        )
      ),
    )
  );

  matchingColumnsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(comparatorsActions.MatchingComparatorsColumns),
      tap(() => {
        this.store.dispatch(comparatorsActions.SetComparatorLoader({ isLoading: true }));
      }),
      switchMap((action) =>
        this.comparatorService.matchingComparatorsColumns(action.id, action.matchingColumns).pipe(
          map((res: APIResponse<IExecuteSeccess>) =>
            comparatorsActions.MatchingComparatorsColumnsSuccess({ executeSeccess: res.object!, test: action.matchingColumns.test })
          ),
          tap((res) => {
            if(action.committed){
              this.commonService.showToast(
                this.translateService.instant(`alerts.${AlertEnums.comparatorAddSuccess}`),
                'SUCCESS'
              );
            }
          }),
          catchError((error) => {
            return of(comparatorsActions.MatchingComparatorsColumnsError({ responseMatching: error.error.object }));
          }),
          finalize(() => {
            this.store.dispatch(comparatorsActions.SetComparatorLoader({ isLoading: false }));
          })
        )
      )
    )
  );


  detailsComparatorEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(comparatorsActions.DetailsComparator),
      tap(() => {
        this.store.dispatch(comparatorsActions.SetComparatorLoader({isLoading: true}));
      }),
      switchMap((action) =>
        this.comparatorService.detailsComparator(action.id).pipe(
          map((res: APIResponse<IExecuteSeccess>) => comparatorsActions.DetailsComparatorSuccess({ deatailsComparator: res.object!})),
          catchError(() =>
            of(
            comparatorsActions.DetailsComparatorError()
            )
          ),
            finalize(() => {
              this.store.dispatch(comparatorsActions.SetComparatorLoader({isLoading: false}));
            })
        )
      )
    )
  );

  ReComparatorProductsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(comparatorsActions.ReImportComparators),
      tap(() => {
        this.store.dispatch(comparatorsActions.SetComparatorLoader({isLoading: true}));
      }),
      switchMap((action) =>
        this.comparatorService.reImportComaparators(action.id, action.file).pipe(
          map((res: APIResponse<IResponseMatching>) => comparatorsActions.ReImportComparatorsSuccess({ responseMatching: res.object!})),
          catchError(() =>
            of(
            comparatorsActions.ReImportComparatorsError()
            )
          ),
          finalize(() => {
            this.store.dispatch(comparatorsActions.SetComparatorLoader({isLoading: false}));
          })
        )
      )
    )
  );
}
